import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'})

export class ConstantService {
    viewLess = 'View Less';
    viewMore = 'View More';
    isLoggedIn = 'isLoggedIn';
    forumPageTitle = 'Customer Support FAQs and Help Guides | 5paisa';
    robots = 'robots';
    description = 'description';
    forumPageDescription = '5paisa Customer Support Knowledge Base';
    forumPageRobotContent = 'index, follow';
    createTicketPageRobotContent = 'noindex, nofollow';
    portalId = 'portalId';
    keywords = 'keywords';
    yes = 'Y';
    no = 'N';
    knowledgeBaseRequestInclude = 'articlesCount,allArticleCount,sectionsCount,followersCount';
    notLoggedInMessage = 'notLoggedIn';
    letsChatBotLink = 'https://invest.5paisa.com/chatbot'; //
    loginUrl = 'https://login.5paisa.com/?returnurl=https://faq.5paisa.com';
    createTicketPageTitle = 'Create a Support Ticket | 5paisa';
    createTokenUserId = '1C861EE4-46BA-4462-97B8-C80895228451';
    CreateTicketObjName = 'CreateTicket';
    clientCode = 'clientCode';
    success = 'Success.';
    noResultFoundText = 'No results found';
    knowledgeBaseText = 'Knowledge Base';
    fivePaisaTextTitle = '5paisa |';
    invalidSessionText = 'Invalid Session';
    jwtToken = 'jwtToken';
    fivePaisaText = '5paisa';

    /** WCAG 2.4.2: topic first, purpose clear, site name last (unique in browser tabs). */
    getKnowledgeBasePageTitle(topicName: string): string {
        return `${topicName} FAQs and Help Guides | 5paisa`;
    }

    getArticlePageTitle(articleTitle: string): string {
        return `${articleTitle} | 5paisa`;
    }

    faqRequestConstant = {
        faqFrom : '1',
        faqLimit : '30',
        faqLimitMax : '100',
        faqSortBy : 'viewCount',
        faqSortByLike : 'likeCount',
        faqlocale : 'en'
    }

    getArticleListRequestConstant = {
        galFrom : '1',
        galLimit : '100',
        galSortBy : 'viewCount',
        gallocale : 'en'
    }

    searchByStringRequestConstant = {
        from : '1',
        limit : '5',
        englishLanguage : 'en'
    }

    checkLoginRequestConstant = {
        appName: '5PTRADE',
        appSource: '21',
        appVer: '1.0',
        key: '',
        osName: 'Web',
        requestCode: '5PCLRes',
    }

    bottomSheetModalMessages = {
        invalid : 'invalid',
        success : 'success',
        pending : 'pending',
        failed : 'failed',
        notLoggedIn : 'notLoggedIn'
    }

    navigationComponentPage = {
        createTicket : 'ticketCreation',
        viewTicket : 'view-ticket',
    }
}


